export default __webpack_public_path__ + "static/media/apple-1.84861cfe.svg";